import {btn, Component, Notifier, router, tbar} from "@intermesh/goui";
import {t} from "./util/Translate.js";
import {registrationForm} from "./components/RegistrationForm.js";
import {ServerApi} from "./util/ServerApi.js";
import {CurrentParticipant} from "./services/CurrentParticipant.js";

export class ConfirmParticipantEdit extends Component {
	constructor() {
		super("section");
		this.itemId = "confirm-registration";
		this.id = "confirm-registration";
		this.cls = "ifw-card";

		const p = registrationForm({readOnly: true});

		p.form.on("submit", async () => {
			p.form.findChild("remindMe")!.disabled = false;

			const v = p.form.value,
				cp = CurrentParticipant.get();
			let route = "elearning/frontend/participants/" + cp.id,
				body = {
					id: cp.id,
					firstName: v.firstName,
					middleName: v.middleName,
					lastName: v.lastName,
					dateOfBirth: v.dateOfBirth,
					email: v.email,
					company: v.company,
					remindMe: v.remindMe
				};

			let cfs = {};
			for(const [key,val] of Object.entries(v)) {
				if(val === undefined  || String(val).length === 0) {
					continue;
				}
				if(key.startsWith("customFields.")) {
					const dbName = key.replace("customFields.", "");
					Object.assign(cfs, {[dbName]: val});
				}
			}
			if (Object.keys(cfs).length > 0) {
				Object.assign(body, {customFields: cfs});
			}

			ServerApi.call(route, body, "PUT").then(async (result) => {
				await CurrentParticipant.refresh(result);
				Notifier.success(t("Saved successfully"), 5000);
				void router.goto("profile");
			});

		});

		p.load().then(() => {
			this.items.add(p);
			p.form.findChild("username")!.hide();
			p.form.findChild("username")!.disabled = true;
			p.form.findChild("password")!.hide();
			p.form.findChild("password")!.disabled = true;
			p.form.findChild("passwordRepeat")!.hide();
			p.form.findChild("passwordRepeat")!.disabled = true;

			this.items.add(tbar({cls: "ifw-bbar"},
				btn({text: t("Back"), route: "participant-edit"}),
				"->",
				btn({
					type: "submit", text: t("Continue"), handler: () => {
						p.form.submit();
					}
				})
			));
		});
	}
}
